import updateConversationsCategoriesInternal from './helpers/updateConversationsCategoriesInternal';
import updateItemsCategoriesInternal from './helpers/updateItemsCategoriesInternal';
import datapoints from '../datapoints';
import { action } from 'satcheljs/lib/legacy';
/**
 * Add categories to the specified rows from the table
 * @param rowKeys of the rows to add categories to
 * @param tableView that contains the rows
 * @param categoriesToAdd the categories to be added to the rows
 * @param actionSource the action source
 * @param createNewCategoryPromise the promise for creating new category request
 */
export var addCategoriesFromTable = action('addCategories', datapoints.addCategories)(function addCategoriesFromTable(rowKeys, tableView, categoriesToAdd, actionSource, createNewCategoryPromise) {
    updateRowCategoriesInternal(rowKeys, tableView, categoriesToAdd, null /* categoriesToRemove */, false /* clearCategories */, actionSource, createNewCategoryPromise);
});
/**
 * Clear categories of the specified rows from the table
 * @param rowKeys of the rows to clear
 * @param tableView that contains the rows
 * @param actionSource the action source
 */
export var clearCategoriesFromTable = action('clearCategories', datapoints.clearCategories)(function clearCategoriesFromTable(rowKeys, tableView, actionSource) {
    updateRowCategoriesInternal(rowKeys, tableView, null /* categoriesToAdd */, null /* categoriesToRemove */, true /* clearCategories */, actionSource);
});
/**
 * Remove categories from the specified rows from the table
 * @param rowKeys of the rows to remove categories to
 * @param tableView that contains the rows
 * @param categoriesToRemove the categories to be removed to the rows
 * @param actionSource the action source
 */
export var removeCategoriesFromTable = action('removeCategoriesFromTable', datapoints.removeCategories)(function removeCategoriesFromTable(rowKeys, tableView, categoriesToRemove, actionSource) {
    updateRowCategoriesInternal(rowKeys, tableView, null /* categoriesToAdd */, categoriesToRemove, false /* clearCategories */, actionSource);
});
/**
 * INternal function to do category operation
 * @param rowKeys of the rows to act upo
 * @param tableView that contains the rows
 * @param categoriesToAdd the categories to be added to the rows
 * @param categoriesToRemove the categories to be removed to the rows
 * @param clearCategories whether to clear categories or not
 * @param actionSource the action source
 * @param promiseToWaitUpon the promise to wait upon before sending the request for category update
 */
function updateRowCategoriesInternal(rowKeys, tableView, categoriesToAdd, categoriesToRemove, clearCategories, actionSource, promiseToWaitUpon) {
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            updateConversationsCategoriesInternal(rowKeys, tableView, categoriesToAdd, categoriesToRemove, clearCategories, actionSource, promiseToWaitUpon);
            break;
        case 1 /* Message */:
            updateItemsCategoriesInternal(rowKeys, tableView, categoriesToAdd, categoriesToRemove, clearCategories, actionSource, promiseToWaitUpon);
            break;
    }
}
//# sourceMappingURL=categoryTriageActions.js.map